import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const local_workspace_billing_balance_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_BILLING_BALANCE_DELETE,
  payload,
});

export const init_local_workspace_billing_balance_delete = (state: StateWorkspaceBilling, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.balances_map.delete(id);
  }

  //nned to force a re-render
  state.balances_map = new Map(state.balances_map);
};
